import { makeLimitedListReducer } from 'utils/factory'

const listReducer = makeLimitedListReducer('devLogs')

const initialState = {}

export default function devLogsReducer(state = initialState, action) {
  return listReducer(state, action)
}
